import { useTranslation } from "react-i18next";
import SvgIcon from "../SvgIcon";

export const MODES = ["sbs", "slider", "fade"];

const MODE_ICONS = {
  sbs: "/img/new-icons/columns-2.svg",
  slider: "/img/new-icons/panel-left-open.svg",
  fade: "/img/new-icons/fade.svg",
};

const ICON_SIZE = { width: "1rem", height: "1rem" };

// Segmented control picking how a pair of photos is compared: side by side,
// with a draggable divider, or cross-faded. Each mode is an icon tile with its
// name underneath; only the tile takes the gradient when active.
//
// `disabledModes` greys out modes the current selection can't support (slider
// and fade need both photos present).
const ModeTabs = ({ mode, onChange, disabledModes = [] }) => {
  const { t } = useTranslation("athlete-portal");
  const labels = {
    sbs: t("questionProgress.sideBySide"),
    slider: t("questionProgress.slider"),
    fade: t("questionProgress.fade"),
  };

  return (
    <div className="mode-tabs compare-panel">
      {MODES.map((m) => (
        <button
          key={m}
          type="button"
          className={m === mode ? "active" : ""}
          disabled={disabledModes.includes(m)}
          onClick={() => onChange(m)}
        >
          <span className="mode-tab-icon">
            {/* Mask-based, so the glyph takes the button's colour — white on
                the active gradient — and keeps fade.svg's half-opacity side. */}
            <SvgIcon src={MODE_ICONS[m]} useCurrentColor style={ICON_SIZE} />
          </span>
          <span className="mode-tab-label">{labels[m]}</span>
        </button>
      ))}
    </div>
  );
};

export default ModeTabs;
